import { createSlice } from "@reduxjs/toolkit";
import ServerRoutes from "../api/routes";
import { get, post } from "../api/http";

const initialState = {
  users: {},
  user: null,
  usersError: null,
  usersLoading: false,
};

const _setUsers = (state, action) => {
  state.users = action.payload;
  state.usersLoading = false;
};

const _setUser = (state, action) => {
  state.user = action.payload;
  state.usersLoading = false;
};

// const _addUser = (state, action) => {
//   let editedUsers = { ...state.users };
//   editedUsers[action.payload.id] = {
//     ...action.payload.body,
//     asmachta: "",
//     link: "",
//     bankName: "",
//     bankNumber: "",
//     feePercent: 2,
//     bankSnif: "",
//     bankOwner: "",
//     notes: "",
//     approved: true,
//     isPaid: false,
//     role: 1,
//     totalGifts: 0,
//     totalFees: 0,
//     setBankDetails: false,
//     done: false,
//     _id: action.payload.id,
//     eventDate: action.payload.eventDate,
//     dateAdded: action.payload.dateAdded,
//     vPassword: action.payload.vPassword,
//   };
//   state.users = editedUsers;
// };

const _editUser = (state, action) => {
  let editedUsers = { ...state.users };
  for (const [key, value] of Object.entries(action.payload.body))
    editedUsers[action.payload._id][key] = value;
  state.users = editedUsers;
  state.usersChange = !state.usersChange;
};

const _actionStart = (state, action) => {
  state.usersLoading = true;
  state.usersError = null;
};

const _actionSuccess = (state, action) => {
  state.usersLoading = false;
  state.usersError = null;
};

const _actionFailed = (state, action) => {
  state.usersLoading = false;
  state.usersError = action.payload.error;
};

const _deleteUser = (state, action) => {
  let editedUsers = { ...state.users };
  delete editedUsers[action.payload];
  state.users = editedUsers;
};

const users = createSlice({
  name: "users",
  initialState,
  reducers: {
    setUsers: _setUsers,
    setUser: _setUser,
    editUser: _editUser,
    deleteUser1: _deleteUser,
    actionStart: _actionStart,
    actionFailed: _actionFailed,
    actionSuccess: _actionSuccess,
  },
});

const { reducer, actions } = users;

export const {
  setUsers,
  setUser,
  editUser,
  deleteUser1,
  actionStart,
  actionFailed,
  actionSuccess,
} = actions;

export default reducer;

export const getOne = (data) => {
  return async (dispatch) => {
    const result = await get(ServerRoutes.User.getOne, data);
    dispatch(setUser(result));
  };
};

export const getAll = () => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await get(ServerRoutes.User.getAll, {});
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(setUsers(data));
  };
};

export const getAllProducer = () => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await get(
      ServerRoutes.User.getProducerClients,
      {}
    );
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(setUsers(data));
  };
};

export const cleanAll = () => {
  return async (dispatch) => {
    dispatch(setUsers({}));
  };
};

export const destroyUser = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(ServerRoutes.User.destroyUser, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(deleteUser1(body.id));
    }
  };
};

export const editUserById = (_id, body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(ServerRoutes.User.edit + _id, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else {
      dispatch(actionSuccess());
      return dispatch(
        editUser({
          _id,
          body,
        })
      );
    }
  };
};

export const editUserFirstCall = (_id, body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { error, status } = await post(ServerRoutes.User.edit + _id, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess());
  };
};

export const add = (body) => {
  return async (dispatch) => {
    dispatch(actionStart());
    const { data, error, status } = await post(ServerRoutes.User.addBS, body);
    if (status !== 200) return dispatch(actionFailed({ error }));
    else return dispatch(actionSuccess());
  };
};
